import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type OrgsEvents = 'CREATE_SUB_ORG' | 'EXPORT_ORG_RESULT';

export const org: Record<OrgsEvents, MixpanelEvent> = {
  CREATE_SUB_ORG: {
    eventDescription: 'Create Sub Organization',
    eventKey: 'create-sub-organization',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  EXPORT_ORG_RESULT: {
    eventDescription: 'Export Organization Result',
    eventKey: 'export-organization-result ',
    eventSource: EventSource.SERVER_EVENT,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  }
} as const;
